/**
 * Production-safe logger utility.
 * Silences all output in production builds automatically.
 */
const isDev = process.env.NODE_ENV !== 'production';

const logger = {
  error: (...args) => isDev && console.error(...args),
  warn: (...args) => isDev && console.warn(...args),
  info: (...args) => isDev && console.log(...args),
};

export default logger;
